import React, { useState, useEffect, useContext } from 'react';

import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';

import Snackbar from '@material-ui/core/Snackbar';
import Slide from '@material-ui/core/Slide';
import Alert from '@material-ui/lab/Alert';

import OrderItem from "./OrderItemCard";

import { SessionContext } from "../context/session-context";


const useStyles = makeStyles({
    root: {

    },
    selectContainer:{
        '& .MuiSelect-select.MuiSelect-select':{
            height: 'calc(100vh - 300px)',
        },
        marginTop:10,
        marginRight:10,
        border: '2px solid #3D3E4F',
    },
    selectObject:{
        width:'100%'
    },
    textItemFont:{
        fontSize:12
    }

  });


export default function ClientsPanel() {
    const classes = useStyles();
  
    const [sState, sDispatch] = useContext(SessionContext);
    const [orderRows, setOrderRows] = useState([]);
    const [companyid, setCompanyid] = useState();
    const [orderid, setOrderid] = useState(0);

    const [severity, setSeverity] = useState('success');
    const [msg, setMsg] = useState('');
    const [snackOpen, setSnackOpen] = useState(false);


    const handleOrderSearch = () => {


    }

    const handleError = function (err) {
        console.log(err);
        return new Response(JSON.stringify({
          code: 400,
          message: 'Stupid network Error'
        }));
    };

    const doOrderSearch = () => {
        console.log("doOrderSearch called: ");
        if (!isNaN(parseInt(orderid))){

            const abortController = new AbortController();

            let mounted = true;
            (async () => {  
              const res = await fetch(process.env.REACT_APP_FIND_API+'/order/getorder?orderid='+orderid, {
                method: 'GET',
                headers: {'Content-Type': 'application/json'},
                signal: abortController.signal,
              }).catch(handleError);
              const data = await res.json();
              if (mounted) {
                //console.log("get orders function: "+JSON.stringify(data));
                if (data.status === "success" && data.orders.length > 0){
                    setOrderRows(data.orders);
                } else {
                    setOrderRows([]);
                }
              }
              const cleanup = () => {
                mounted = false;
                abortController.abort();
              };
              return cleanup;
          
          })();

        }
    }

    const handleSnackClose=()=>{
        setSnackOpen(false);
    }

    return (
        <div className={classes.root}>
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={snackOpen}
                autoHideDuration={6000}
                onClose={handleSnackClose}
                TransitionComponent={Slide}
                TransitionProps={{ direction: 'down' }}
            >
                <Alert onClose={handleSnackClose} severity={severity}>
                {msg}
                </Alert>
            </Snackbar>
            <Grid container>
                <Grid item xs={12}>
                    <Box className={classes.formLabel} fontWeight="500" fontStyle="italic" fontSize={22} >Edit orders</Box>
                </Grid>
                <Grid item xs={12}>
                    <Box>
                        <TextField className={classes.textField} InputProps={{classes: {input: classes.textItemFont}}} name="orderid" label="Order ID" size="small" margin="dense" variant="outlined" value={orderid} onChange={e => setOrderid(e.target.value)}/>
                        <Button className={classes.filterButton} variant="contained" onClick={doOrderSearch} >
                            <Box fontWeight="fontWeightRegular" fontSize={12} >Search</Box>
                        </Button>
                    </Box>
                </Grid>
                <Grid item xs={12}>
                    <div className={classes.ordertable}>
                        {orderRows.map((item, i) =>
                            <OrderItem key={i} item={item} />
                        )}
                    </div>
                </Grid>
            </Grid>
        </div>
    )
  };
